
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface TransactionTypeFieldProps {
  value: 'receita' | 'despesa';
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  hideLabel?: boolean;
}

export const TransactionTypeField = ({ value, onChange, error, disabled, hideLabel }: TransactionTypeFieldProps) => {
  return (
    <div>
      {!hideLabel && <Label htmlFor="type">Tipo da Transação</Label>}
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={`rounded-xl ${error ? 'border-destructive' : ''}`}>
          <SelectValue placeholder="Selecionar tipo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="receita">
            <div className="flex items-center gap-2">
              <TrendingUp className="h-4 w-4 text-green-600" />
              Receita
            </div>
          </SelectItem>
          <SelectItem value="despesa">
            <div className="flex items-center gap-2">
              <TrendingDown className="h-4 w-4 text-red-600" />
              Despesa
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
      {error && (
        <p className="text-sm text-destructive mt-1">{error}</p>
      )}
    </div>
  );
};

